import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  constructor(private translate: TranslateService) {
    const saved = this.current;
    this.translate.setDefaultLang('en');
    this.translate.use(saved);
    document.documentElement.lang = saved;
  }

  get current(): 'ta' | 'en' {
    // English is the default for a fresh install; once the user picks a
    // language on the profile page that choice is stored and wins from then on.
    return (localStorage.getItem('lang') as 'ta' | 'en') || 'en';
  }

  apply(lang: 'ta' | 'en'): void {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    document.documentElement.lang = lang;
  }
}
